// @flow
import React, { useEffect, useState, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';
import Divider from '@mui/material/Divider';
import CssBaseline from '@mui/material/CssBaseline';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';

function DeptListDialog(props) {

  const { open, depts, selDeptCode, onClose, onSelDept } = props;


  const handleItemClick = (event, ADeptCode) => {
    onSelDept && onSelDept(ADeptCode);
  }

  const handleCloseClick = () => {
    onClose && onClose();
  }

  return (

    // <Box sx={{ width: '100%', bgcolor: 'background.paper' }}>
    //   <CssBaseline />
    <Dialog
      fullWidth={true}
      maxWidth={"sm"}
      open={open}
      // onClose={handleCloseClick}
      aria-describedby="dialog-deptlist"
    >
      <DialogTitle>Select department</DialogTitle>
      <DialogContent>
        <nav aria-label="Department list">
          <List dense={true}>
            {(depts || []).map((dept, idx) => {
              return (
                <div key={dept.DeptCode}>
                  < ListItem disablePadding >
                    <ListItemButton
                      selected={dept.DeptCode == selDeptCode}
                      onClick={(e) => handleItemClick(e, dept.DeptCode)} >
                      <ListItemText primary={dept.DeptName} />
                    </ListItemButton>
                  </ListItem>
                  <Divider />
                </div>
              );
            })}
          </List>
        </nav>


      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseClick}>Close</Button>
      </DialogActions>
    </Dialog>


    // </Box >
  );
}

DeptListDialog.propTypes = {
  open: PropTypes.bool,
  depts: PropTypes.array,
  selDeptCode: PropTypes.string,
  onClose: PropTypes.func,
  onSelDept: PropTypes.func,
};

export default DeptListDialog